export enum GuestAccessClaims {
  UpdateLayout = 'UpdateLayout',
  UpdateAttendee = 'UpdateAttendee',
}
